
import './App.css';
import {BrowserRouter} from "react-router-dom";
import {Route, Routes} from "react-router";
import Dashboard from "./dashboard/Dashboard";
import AuthPath from "./auth/AuthPath";
import Bootstrapper from "./bootstrap/Bootstrapper";
import {createContext, useState} from "react";
import SetupModal from "./modals/SetupModal";
import ExpenseModal from "./modals/ExpenseModal";
import TestCompanyInfo from "./tests/LoadCompanyInfoTest";
import Dashboard2 from "./dashboard/Dashboard2";

export const ManifestContext = createContext(null);


function App() {

    const noop = () => {}
    const [manifest, setManifest] = useState(null);
    const [year, setYear] = useState(2024);

    return (
        <div className="App">
            <ManifestContext.Provider value={ {manifest: manifest, setManifest: setManifest} }>
              <BrowserRouter>
                <Routes>
                    <Route path={"/"} element={<AuthPath/>}/>
                    {/*<Route path={"/load"} element={<Bootstrapper/>}/>*/}
                    {/*<Route path={"/dashboard"} element={<Dashboard/>}/>*/}
                    <Route path={"/load"} element={<Dashboard2/>}/>



                    {/*Testing Routes*/}
                    <Route path={"/tests/setup"} element={<SetupModal open={true} stateChange={noop} stateExpenseModal={noop}/>}/>
                    <Route path={"/tests/expenses"} element={<ExpenseModal open={true}/>}/>
                    {/*<Route path={"/tests/dashboard"} element={<Dashboard yearChange={setYear} currentYear={year}/>}/>*/}
                    <Route path={"/tests/loadCompanyInfo"} element={<TestCompanyInfo/>}/>
                    <Route path={"/tests/dashboard2"} element={<Dashboard2/>}/>
                </Routes>
              </BrowserRouter>
            </ManifestContext.Provider>
        </div>
    );
}

export default App;
